import Breadcrumbs from "@/components/site/Breadcrumbs";

export default function PageHero({ eyebrow, title, lead, breadcrumbs = [] }) {
    return (
        <section className="relative overflow-hidden">
            <div className="hero-glow absolute inset-0 pointer-events-none" />
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-16 lg:pt-20 pb-10 sm:pb-14">
                {breadcrumbs.length > 0 && (
                    <div className="mb-6">
                        <Breadcrumbs items={breadcrumbs} />
                    </div>
                )}
                {eyebrow && (
                    <p className="text-xs font-mono uppercase tracking-[0.22em] text-[#7BD3FF]">
                        {eyebrow}
                    </p>
                )}
                <h1 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-white max-w-3xl">
                    {title}
                </h1>
                {lead && (
                    <p className="mt-5 text-base sm:text-lg text-[#C9D3E1] leading-relaxed max-w-3xl">
                        {lead}
                    </p>
                )}
            </div>
        </section>
    );
}
